import { builder } from '@builder.io/react'
import store from 'base/store'

export default function initBuilderKey() {
  const apiKey = store.getState().appConfig.builderApiKey

  if (apiKey) builder.init(apiKey)
}
